export const PROFILE  = 'PROFILE'